window.addEventListener('DOMContentLoaded', function() {
  const quoteButton = document.querySelector('.product-info--request-button');

  if(quoteButton) {
    window.addEventListener('variant:change', function(e) {
      const url = new URL("https://" + window.location.host + quoteButton.getAttribute('href'));
      url.searchParams.set('variant_title', e.detail.variant.title);
      if(e.detail.variant.sku) {
        url.searchParams.set('sku', e.detail.variant.sku);
      } else {
        url.searchParams.set('sku', '');
      }
    });
  }
});

class QuoteForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    if(searchParams.get('product_title') && searchParams.get('product_title') != "") {
      this.querySelector('input[name="contact[product]"]').value = searchParams.get('product_title');
    } else {
      this.querySelector('input[name="contact[product]"]').parentElement.remove();
    }

    if(searchParams.get('sku') && searchParams.get('sku') != "") {
      this.querySelector('input[name="contact[sku]"]').value = searchParams.get('sku');
    } else {
      this.querySelector('input[name="contact[sku]"]').remove();
    }

    if(searchParams.get('variant_title') && searchParams.get('variant_title') != "") {
      this.querySelector('input[name="contact[variant]"]').value = searchParams.get('variant_title');
    } else {
      this.querySelector('input[name="contact[variant]"]').remove();
    }

    this.classList.add('show');
  }
}

customElements.define('quote-form', QuoteForm);


class VatLayerValidator extends HTMLElement {
  constructor() {
    super();
    this.apiKey = this.getAttribute('data-key');
    this.removeAttribute('data-key');

    this.vatInput = this.querySelector(`input[name="customer[note][Vat ID]"]`);
    this.button = this.querySelector('button');

    this.form = this.closest('form');
    this.submitButton = this.form.querySelector('button[type="submit"]');

    this.testedVatNumber = null;

    this.validVatLabel = this.getAttribute('data-valid-label') || 'Valid';
  }

  vat() {
    return this.vatInput.value.trim().replace(/\s+/g, '');
  }

  connectedCallback() {
    
    this.button.addEventListener('click', async (event) => {
      event.preventDefault();
      if (this.vatInput.value.trim() === '') {
        return;
      }
      
      const testedVatNumber = this.vat();
      const isValid = await this.isValid(testedVatNumber);
      if (isValid) {
        this.testedVatNumber = testedVatNumber;
        this.querySelector(`input[name="customer[note][Valid Vat ID]"]`).value = 'true';
        this.vatInput.disabled = true;
        this.button.disabled = true;
        this.submitButton.disabled = false;
        this.button.textContent = this.validVatLabel;
        this.updateCartAttributes();
        this.classList.remove('invalid-vat-number');
        this.classList.add('valid-vat-number');
      } else {
        this.querySelector(`input[name="customer[note][Valid Vat ID]"]`).value = 'false';
        this.classList.add('invalid-vat-number');
        this.classList.remove('valid-vat-number');
      }

      this.updateSubmitButton();
    });

    this.vatInput.addEventListener('input', () => {
      this.testedVatNumber = null;
      this.querySelector(`input[name="customer[note][Valid Vat ID]"]`).value = 'false';
      this.classList.remove('invalid-vat-number');
      this.classList.remove('valid-vat-number');
      this.updateSubmitButton();
    });
  }

  updateSubmitButton() {
    this.submitButton.disabled = this.vatInput.value.trim() !== "" && this.testedVatNumber === null;
  }
  
  async isValid(vat) {
    const response = await fetch(`https://apilayer.net/api/validate?access_key=${this.apiKey}&vat_number=${vat}`);
    const data = await response.json();
    return data?.valid ?? false;
  }

  isCheckedAndValid() {
    console.log('Checking if valid : ' + (this.testedVatNumber !== null ? "valid": "not valid"))
    return this.testedVatNumber !== null;
  }

  async updateCartAttributes() {
    if (!this.isCheckedAndValid()) {
      console.log("returning");
      return;
    }
    const vat = this.testedVatNumber;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: {
        'vat_id_for_exemptify': vat,
        'local-vat-id': vat,
        'vat-id': vat
      } }) // LU26375245
    });
  }
}

customElements.define('vat-layer-validator', VatLayerValidator);